module.exports = __webpack_public_path__ + "static/media/7.a10b927b.jpg";